import { createContext, useState } from "react";
import { useDispatch } from "react-redux";

import {
  createFailingReasonService,
  deleteFailingReasonService,
  getFailingReasonService,
} from "./../../../services/userServices";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../../redux/actions/loadingActions/loadingActions";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";

export const failingReasonAdminContext = createContext({
  failingReasonItems: [],
  setFailingReasonItems: () => {},
  description: "",
  setDescription: () => {},
  isShowModal: null,
  setIsShowModal: () => {},
  handleShowModal: () => {},
  handleCloseModal: () => {},
  handleGetFailingReasonItemList: () => {},
  handleCreateFailingReasonItem: () => {},
  handleDeleteFailingReasonItem: () => {},
});

const FailingReasonAdminContext = ({ children }) => {
  // Redux Dispatch
  const dispatch = useDispatch();

  const [failingReasonItems, setFailingReasonItems] = useState([]);
  const [description, setDescription] = useState("");
  const [isShowModal, setIsShowModal] = useState(false);

  const handleResetState = () => {
    setDescription("");
  };

  // Create Failing Reason Modal Operations
  const handleShowModal = () => setIsShowModal(true);
  const handleCloseModal = () => {
    setIsShowModal(false);
    handleResetState();
  };

  // Handle Get Failing Reason Item List Method
  const handleGetFailingReasonItemList = async (event) => {
    event?.preventDefault();
    const objData = {
      offset: 0,
      limit: 100,
    };
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getFailingReasonService(objData);
      if (status === 200) {
        setFailingReasonItems(data.results);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Create Failing Reason Item Method
  const handleCreateFailingReasonItem = async (event) => {
    event?.preventDefault();

    const objData = {
      description,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await createFailingReasonService(objData);
      if (status === 200) {
        toastSuccessMessage("آیتم با موفقیت ایجاد شد");
        handleGetFailingReasonItemList();
        handleCloseModal();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Delete Failing Reason Item Method
  const handleDeleteFailingReasonItem = async (id) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status } = await deleteFailingReasonService(id);
      if (status === 200) {
        toastSuccessMessage(`آیتم  ${id} با موفقیت حذف شد`);
        handleGetFailingReasonItemList();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <failingReasonAdminContext.Provider
      value={{
        failingReasonItems,
        setFailingReasonItems,
        description,
        setDescription,
        isShowModal,
        setIsShowModal,
        handleShowModal,
        handleCloseModal,
        handleGetFailingReasonItemList,
        handleCreateFailingReasonItem,
        handleDeleteFailingReasonItem,
      }}
    >
      {children}
    </failingReasonAdminContext.Provider>
  );
};

export default FailingReasonAdminContext;
